<template>
  <div>
    <!--form表单-->
    <el-form size="small" ref="formData" :model="formData" label-width="150px">
      <div class="common-form">银行</div>
      <el-form-item label="Bank Name" :rules="[{ required: true, message: '请输入Bank Name' }]">
        <el-input v-model="formData.bank_name" placeholder="请输入Bank Name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="Account Holder Name" :rules="[{ required: true, message: '请输入Account Holder Name' }]">
        <el-input v-model="formData.account_holder" placeholder="请输入Account Holder Name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="Account Number" :rules="[{ required: true, message: '请输入Account Number' }]">
        <el-input v-model="formData.account_number" placeholder="请输入Account Number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="Routing Number" :rules="[{ required: true, message: '请输入Routing Number' }]">
        <el-input v-model="formData.routing_number" placeholder="请输入Routing Number" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="Account Type" :rules="[{ required: true, message: '请选择Account Type' }]">
        <el-select v-model="formData.account_type">
          <el-option label="Checking" value="checking"/>
          <el-option label="Savings" value="savings"/>
        </el-select>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper"><el-button size="small" type="primary" @click="onSubmit" :disabled="loasing_submit">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import cashApi from '@/api/cash.js';
export default {
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*是否在提交*/
      loasing_submit: false,
      /*表单数据对象*/
      formData: {
        bank_name:'',
        account_holder:'',
        account_number:'',
        routing_number:'',
        account_type:''
      },
      app_id:10001
    };
  },
  created() {
    this.getParams();
  },
  methods: {
    /*获取配置数据*/
    getParams() {
      let self = this;
      cashApi
        .getAccount({
          app_id:10001
        }, true)
        .then(res => {
          if (res.code == 1) {
            self.formData = res.data.model;
            self.loading = false;
          } else {
            console.log();
          }
        })
        .catch(error => {});
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      params.app_id = self.app_id;
      self.$refs.formData.validate(valid => {
        if (valid) {
          self.loasing_submit = true;
          cashApi
            .setAccount(params, true)
            .then(data => {
              self.loasing_submit = false;
              self.$message({
                message: '恭喜你，保存设置成功',
                type: 'success'
              });
            })
            .catch(error => {
              self.loasing_submit = false;
            });
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/cash/cash/account.vue